import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import { _CommercialCampaign, _CustomerType, _DistributionChannel } from '../../../../core/services/dataBean/EntityCatalogVdos';
import usePaginator from '../../../theme/Component/usePaginator';
import { AccountantYear } from '../../../Talentohumano/GestionTH/EmployeeContract/ProductionPlan/AccountantYear';
import { MonthEditorbyconst } from '../../../RemoteAbstractAction/editors/MonthEditorbyconst';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';
import { AccountEditor } from '../../../editor/AccountEditor';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const CustomerTypeTwoEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_CustomerType)
    const [id, setID] = useState(null);
    const [Account, setAccount] = useState<number>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const [month, setMonth] = useState<any>(null);
    const [year, setYear] = useState<any>(_single.getCurrenYear());
    const modal = useModal("Segmentación de Clientes", MODAL_md);
    const paginador = usePaginator();
    useEffect(() => {
        setID(idSelector)
    }, [idSelector])


    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDCustomerType == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        instance.getCustomerTypeCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)

                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDCustomerType', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }

    return (
        <>
            <label>{label ?? "Segmentación de Clientes"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDCustomerType); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    </div>
                </div>

            </Modal>
        </>
    )
}